// @flow

import { generateRoomWithoutSeparator } from '@jitsi/js-utils/random';
import { Component } from 'react';

import { isRoomValid } from '../base/conference';
import { toState } from '../base/redux';
import { isSupportedBrowser } from '../base/environment';
import { Conference } from '../conference';
import { PreConference } from '../conference';
import { getDeepLinkingPage } from '../deep-linking';
import { UnsupportedDesktopBrowser } from '../unsupported-browser';
import {
    BlankPage,
    WelcomePage,
    isWelcomePageUserEnabled
} from '../welcome';
import { UnauthorizedConference } from '../conference/components';
import { PasswordProtectedConference } from '../conference/components';
import { WaitingRoomConference } from '../conference/components';
import moment from 'moment';
import baseApi from '../../../baseApiUrl';

/**
 * Object describing application route.
 *
 * @typedef {Object} Route
 * @property {Component} component - React Component constructor.
 * @property {string|undefined} href - New location, in case navigation involves
 * a location change.
 */
export type Route = {
    component: Class<Component<*>>,
    href: ?string
};

/**
 * Determines which route is to be rendered in order to depict a specific Redux
 * store.
 *
 * @param {(Function|Object)} stateful - THe redux store, state, or
 * {@code getState} function.
 * @returns {Promise<Route>}
 */
export function _getRouteToRenderPrevious(stateful: Function | Object): Promise<Route> {
    const state = toState(stateful);
    const route = _getEmptyRoute();
    route.component = BlankPage;

    return Promise.resolve(route);
}
export function _getRouteToRender(stateful: Function | Object): Promise<Route>  {
    const state = toState(stateful);

    return _getWebConferenceRoute(state) || _getWebWelcomePageRoute(state);
}



/**
 * Returns the {@code Route} to display when trying to access a conference if
 * a valid conference is being joined.
 *
 * @param {Object} state - The redux state.
 * @returns {Promise<Route>|undefined}
 */
function _getWebConferenceRoute(state): ?Promise<Route> {
    if (!isRoomValid(state['features/base/conference'].room)) {
        return;
    }

    const route = _getEmptyRoute();

    // Update the location if it doesn't match. This happens when a room is
    // joined from the welcome page. The reason for doing this instead of using
    // the history API is that we want to load the config.js which takes the
    // room into account.
    const { locationURL } = state['features/base/connection'];
    window.finalLocation = locationURL.href;
    console.log("locxation url here",locationURL);
    if (window.location.href !== locationURL.href) {
        route.href = locationURL.href;

        return Promise.resolve(route);
    }

    var search = locationURL.search;
    if (search != undefined) {
        search = search.substring(1);
        if(search != undefined) {
            let jsonContent = decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"');
            let urlGetParams = null;
            if (jsonContent != undefined && jsonContent != "") {
                urlGetParams = JSON.parse('{"' + jsonContent + '"}');
            }
            let accessToken = null;
            let password = null;
            let waitingHash = null;
            let memberId = null; 
            if (urlGetParams) {
                accessToken = urlGetParams['accessToken'] != undefined ? urlGetParams['accessToken'] : null;
                password = urlGetParams['password'] != undefined ? urlGetParams['password'] : null;
                waitingHash = urlGetParams['waitingHash'] != undefined ? urlGetParams['waitingHash'] : null;
                memberId = urlGetParams['memberId'] != undefined ? urlGetParams['memberId'] : null;
            }
            // route.component = PasswordProtectedConference;
            // return Promise.resolve(route);
            var meetingId = locationURL.pathname.substring(1);
            return fetch(`${baseApi}/api/v1/join`, {
                method: "POST",
                mode: 'cors',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "meeting_id": meetingId,
                    "access_token": accessToken,
                    "password": password,
                    "waiting_hash": waitingHash,
                    "member_id": memberId
                })
            })
                .then(res => {console.log("rds here",res); return res.json();})
                .then((result) => {
                    console.log("result herre 1",result);
                    if(result['authorized']!= undefined) {
                        console.log("log 1")
                        let authorizedStatus = result['authorized'];
                        let accessTokenAuthorized = false;
                        let passwordAuthorized = false;
                        let waitingHashAuthorized = false;
                        if (authorizedStatus) {
                            console.log("log 2")
                            accessTokenAuthorized = authorizedStatus["access_token_authorized"] != undefined ? authorizedStatus["access_token_authorized"] : false;
                            passwordAuthorized = authorizedStatus["password_authorized"] != undefined ? authorizedStatus["password_authorized"] : false;
                            waitingHashAuthorized = authorizedStatus["waiting_hash_authorized"] != undefined ? authorizedStatus["waiting_hash_authorized"] : false;
                            console.log("log 3", accessTokenAuthorized, passwordAuthorized, waitingHashAuthorized)
                        }
                        window.meetingId = meetingId;
                        let fullName = result["full_name"];
                        return getDeepLinkingPage(state)
                            .then(deepLinkComponent => {
                                if(deepLinkComponent) {
                                    route.component = deepLinkComponent;
                                } else {
                                    if (isSupportedBrowser()) {
                                        if (accessTokenAuthorized == "authorized") {
                                            if (passwordAuthorized != "authorized") {
                                                if (passwordAuthorized == "unauthorized") {
                                                    route.component = UnauthorizedConference;
                                                } else {
                                                    route.component = PasswordProtectedConference;
                                                }
                                            } else if (waitingHashAuthorized != "authorized") {
                                                if (waitingHashAuthorized == "unauthorized") {
                                                    route.component = UnauthorizedConference;
                                                } else {
                                                    //window.enteredparticipantName = "";
                                                    window.participantName = fullName;
                                                    console.log("FULLNANEEE", fullName);
                                                    route.component = WaitingRoomConference;
                                                }
                                            } else {
                                                if (deepLinkComponent) {
                                                    route.component = deepLinkComponent;
                                                } else if (isSupportedBrowser()) {
                                                    window.participantType = result["participant_type"];
                                                    window.waitingHash = waitingHash;
                                                    console.log("is supported browser 2")
                                                    if (localStorage.getItem('allowJoinMeeting') == null || localStorage.getItem('allowJoinMeeting') == "") {
                                                        route.component = PreConference;
                                                        console.log(PreConference)
                                                        console.log("after Rounting")
                                                    }
                                                    else {
                                                        if (window.participantName == "" || window.participantName == undefined) {
                                                            console.log("IN HEREEE")
                                                            window.participantName = localStorage.getItem("enteredName");
                                                        }
                                                        if (window.participantType != 'doctor') {
                                                            window.startTime = moment.utc();
                                                        }
                                                        console.log("deleting waiting hash", waitingHash);
                                                        console.log(window.participantName, "PARTNAME")
                                                        var participantType = result["participant_type"];
                                                        localStorage.setItem('allowJoinMeeting', "");
                                                        console.log("before Conf", window.location.href)
                                                        route.component = Conference;
                                                        console.log("After Conf", window.location.href);
                                                        console.log("App state here", APP.store.getState());
                                                        // to change participant role based on the type
                                                        // let role = 'none'
                                                        
                                                        // if(window.participantType === 'doctor'){
                                                        //     role = 'moderator'
                                                        //     APP.store.dispatch(localParticipantRoleChanged(role));
                                                        //     APP.API.notifyUserRoleChanged(id, role);
                                                        // } else {
                                                        //     APP.store.dispatch(participantRoleChanged(id, role));
                                                        // }
                                                        if (waitingHash && participantType != "doctor")
                                                            fetch(`${baseApi}/api/v1/deleteWaitingHash`, {method: "POST",mode: 'cors',cache: 'no-cache',headers: {'Content-Type': 'application/json'},body: JSON.stringify({"hash_id": waitingHash})});
                                                    }
                                                    console.log("after 1st else")
                                                }
                                                console.log("after 2nd else")
                                            }
                                            console.log("after 3rd else")
                                        } else {
                                            route.component = UnauthorizedConference;
                                        }
                                    } else {
                                        route.component = UnsupportedDesktopBrowser;
                                    }
                                }
                                console.log("before return route")
                                console.log(route);
                                return route;
                            });
                    } else {
                        route.component = UnauthorizedConference;
                        return route;
                    }
                }).catch(err=>{
                    route.component = UnauthorizedConference;
                    console.log("Some exception happened");
                    return route;
                });
        }
    }
    console.log("Now here1");
    console.log(route);
// return getDeepLinkingPage(state)
//         .then(deepLinkComponent => {
//             if (deepLinkComponent) {
//                 route.component = deepLinkComponent;
//             } else if (isSupportedBrowser()) {
//                 route.component = Conference;
//             } else {
//                 route.component = UnsupportedDesktopBrowser;
//             }

//             return route;
//         });
    return Promise.resolve(route);
}

/**
 * Returns the {@code Route} to display when trying to access the welcome page.
 *
 * @param {Object} state - The redux state.
 * @returns {Promise<Route>}
 */
function _getWebWelcomePageRoute(state): Promise<Route> {
    const route = _getEmptyRoute();

    if (isWelcomePageUserEnabled(state)) {
        if (isSupportedBrowser()) {
            route.component = WelcomePage;
        } else {
            route.component = UnsupportedDesktopBrowser;
        }
    } else {
        // Web: if the welcome page is disabled, go directly to a random room.

        let href = window.location.href;

        href.endsWith('/') || (href += '/');
        route.href = href + generateRoomWithoutSeparator();
    }

    return Promise.resolve(route);
}

/**
 * Returns the default {@code Route}.
 *
 * @returns {Route}
 */
function _getEmptyRoute(): Route {
    return {
        component: BlankPage,
        href: undefined
    };
}
